<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>Upload</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg" :disabled="e1 == 2 || e1 == 3">
              <v-card-text>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 lg12 pa-2>
                    <div v-if="!file">
                      <div
                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                        @dragenter="dragging = true"
                        @dragleave="dragging = false"
                      >
                        <div class="dropZone-info" @drag="onChange">
                          <span class="dropZone-title">
                            <h3>
                              <v-icon size="38" color="#077893"
                                >mdi-inbox-arrow-down-outline</v-icon
                              >
                            </h3>
                          </span>
                          <div class="dropZone-upload-limit-info">
                            <div>
                              {{ $t("email.text3") }}
                            </div>
                            <div>{{ $t("email.text4pdf") }}</div>
                            <div class="red--text pt-4">
                              <b> ***</b> {{ $t("email.Notepdf") }} และมีขนาดไฟล์ไม่เกิน 5 MB
                            </div>
                          </div>
                        </div>
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .bmp, .svg, .webp, .pdf"
                          @change="onChange"
                        />
                      </div>
                    </div>
                    <div v-else class="dropZone-uploaded">
                      <div
                        v-if="pdfLoad"
                        class="d-flex text-center justify-center"
                      >
                        <div class="my-15">
                          <v-layout row wrap justify-center align-center>
                            <v-flex lg12 text-center>
                              <div class="success--text">
                                <v-progress-circular
                                  :size="70"
                                  :width="10"
                                  color="#077893"
                                  indeterminate
                                  :disabled="pdfLoad"
                                ></v-progress-circular>
                              </div>
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <div v-else-if="!pdfLoad">
                        <div class="text-end mt-1 mr-2">
                          <v-btn icon color="pink" @click="removeFile">
                            <v-icon large>mdi-close-circle-outline</v-icon>
                          </v-btn>
                        </div>
                        <!-- <div class="dropZone-uploaded-info"> -->
                        <div>
                          <div class="my-7">
                            <v-layout row wrap justify-center align-center>
                              <v-flex lg12 text-start v-if="file.name == null">
                                <div class="red--text">
                                  <v-icon large color="error"
                                    >mdi-file-cancel</v-icon
                                  >
                                  <b> ***</b> กรุณาอัปโหลดเอกสาร
                                </div>
                              </v-flex>
                              <v-flex lg12 text-center v-else>
                                <div class="success--text">
                                  <v-icon large color="success"
                                    >mdi-file-check</v-icon
                                  >
                                  {{ file.name }}
                                  <v-chip color="#388E3C" dark class="ml-10">
                                    {{ $t("template.text13") }}
                                  </v-chip>
                                </div>
                              </v-flex>
                              <!-- <v-flex lg3 text-end>
                              <v-chip color="#388E3C" dark>
                                {{ $t("template.text13") }}
                              </v-chip>
                            </v-flex> -->
                            </v-layout>
                          </div>
                          <!-- <span class="dropZone-title">{{ file.name }}</span> -->
                          <div class="text-center">
                            <b class="red--text mr-1">*</b>
                            <b class="black--text pt-7 text-center">
                              {{ $t("email.Commentpdf") }}
                            </b>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="uploadedFile-info">
                      <div>fileName: {{ file.name }}</div>
                      <div>fileZise(bytes): {{ file.size }}</div>
                      <div>extension：{{ extension }}</div>
                    </div> -->
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center v-if="!pdfLoad">
          <v-flex xs11 lg11>
            <v-stepper class="rounded-lg" v-model="e1">
              <v-stepper-items>
                <v-stepper-content step="1">
                  <div v-if="!pdfLoad">
                    <v-card class="mb-12" color="white lighten-1" elevation="0">
                      <v-layout row wrap justify-start align-center>
                        <v-flex xs11 sm11 md6 lg6>
                          <b>{{ $t("consentlist.Specifysearchconditions") }}</b>
                        </v-flex>
                        <!-- <v-flex lg6 v-if="file.name == null">
                              <div class="red--text">
                                <v-icon large color="error"
                                  >mdi-file-cancel</v-icon
                                >
                                <b> ***</b> กรุณาอัปโหลดเอกสาร
                              </div>
                            </v-flex>
                            <v-flex lg6 v-else>
                              <div class="success--text">
                                <v-icon large color="success"
                                  >mdi-file-check</v-icon
                                >
                                {{ file.name }}
                              </div>
                            </v-flex> -->
                      </v-layout>
                      <br />
                      <v-form ref="form" v-model="valid">
                        <v-layout row wrap justify-space-between align-center>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-identifier"
                              label="Username"
                              color="#077893"
                              v-model="oneid"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-account-outline"
                              :label="$t('NewUpdate.Name')"
                              color="#077893"
                              v-model="name"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-phone-outline"
                              :label="$t('upload.tel')"
                              color="#077893"
                              v-model="phone"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-email-outline"
                              :label="$t('upload.email')"
                              color="#077893"
                              v-model="email"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-start align-center mt-n5>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-card-text-outline"
                              :label="$t('consentlist.Idcard')"
                              color="#077893"
                              v-model="cardid"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-passport"
                              :label="$t('NewUpdate.text4')"
                              color="#077893"
                              v-model="passport"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm11 md3 lg3 pa-2>
                            <v-text-field
                              outlined
                              dense
                              append-icon="mdi-identifier"
                              :label="$t('NewUpdate.corporatenumber')"
                              color="#077893"
                              v-model="bizid"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card>
                    <v-layout row wrap justify-end mt-n14>
                      <v-flex xs3 sm3 md2 lg2 text-end>
                        <v-btn block dark color="#077893" @click="validate">
                          {{ $t("upload.next") }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-card class="mb-12" color="white lighten-1" elevation="0">
                    <v-layout row wrap justify-space-between align-baseline>
                      <v-flex xs12 lg5>
                        {{ $t("NewUpdate.noteDetail") }}
                        <br />
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap justify-start align-center>
                            <v-flex xs12 lg12 ml-2>
                              <v-radio-group v-model="TypeConsent" row>
                                <v-radio
                                  color="#077893"
                                  :label="$t('dashboard.generalType')"
                                  value="general"
                                ></v-radio>
                                &nbsp;
                                <v-radio
                                  color="#077893"
                                  :label="$t('dashboard.groupType')"
                                  value="group"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>
                          <div v-if="TypeConsent == 'general'">
                            <v-layout row wrap justify-start align-center>
                              <v-flex xs12 lg8>
                                <b
                                  ><span class="error--text">*</span>
                                  {{ $t("onechat.text8") }}</b
                                >
                                <v-select
                                  color="#077893"
                                  v-model="ItemPolicyId"
                                  dense
                                  outlined
                                  :items="ItemPolicy"
                                  item-text="Title"
                                  item-value="PolicyId"
                                ></v-select>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap justify-start align-center>
                              <v-flex xs12 lg8>
                                <b
                                  ><span class="error--text">*</span>
                                  {{ $t("onechat.text9") }}</b
                                >
                                <v-select
                                  color="#077893"
                                  v-model="ItemConsentGeneralId"
                                  dense
                                  outlined
                                  :items="ItemConsentGeneral"
                                  item-text="HeaderConsent"
                                  item-value="ConsentId"
                                  return-object
                                ></v-select>
                              </v-flex>
                            </v-layout>
                          </div>
                          <div v-if="TypeConsent == 'group'">
                            <v-layout row wrap justify-start align-center>
                              <v-flex xs12 lg8>
                                <b
                                  ><span class="error--text">*</span>
                                  {{ $t("consentlist.groupconsent") }}</b
                                >
                                <v-select
                                  color="#077893"
                                  dense
                                  outlined
                                  v-model="ItemConsentGroupId"
                                  :items="ItemConsentGroup"
                                  item-text="GroupName"
                                  item-value="GroupId"
                                  return-object
                                ></v-select>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-form>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <v-card
                          color="grey lighten-2"
                          outlined
                          v-if="
                            TypeConsent == 'general' &&
                            ItemPolicyId !== '' &&
                            ItemConsentGeneralId !== ''
                          "
                        >
                          <v-layout row wrap justify-center align-center>
                            <v-flex lg12>
                              <v-data-table
                                dense
                                hide-default-footer
                                :headers="headers"
                                :items="itemDataConsent"
                              >
                                <template v-slot:item="props">
                                  <tr
                                    @dblclick="
                                      fn_getDataConsent(props.item.ConsentId)
                                    "
                                    class="text-center"
                                  >
                                    <td>
                                      {{ props.item.HeaderConsent }}
                                    </td>
                                    <td>
                                      <v-radio-group
                                        v-model="StatusConsent"
                                        row
                                      >
                                        <v-layout
                                          row
                                          wrap
                                          justify-center
                                          align-center
                                        >
                                          <v-flex lg6>
                                            <v-radio
                                              value="approve"
                                              color="success"
                                            ></v-radio>
                                          </v-flex>
                                          <v-flex lg6>
                                            <v-radio
                                              value="unapprove"
                                              color="error"
                                            ></v-radio>
                                          </v-flex>
                                        </v-layout>
                                      </v-radio-group>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </v-card>
                        <v-card
                          color="grey lighten-2"
                          outlined
                          v-if="
                            TypeConsent == 'group' && ItemConsentGroupId !== ''
                          "
                        >
                          <v-layout row wrap justify-center align-center>
                            <v-flex lg12>
                              <v-data-table
                                dense
                                hide-default-footer
                                :headers="headersGroup"
                                :items="GroupConsent"
                              >
                                <template v-slot:item="props">
                                  <tr
                                    @dblclick="
                                      fn_getDataConsent(props.item.ConsentId)
                                    "
                                    class="text-center"
                                  >
                                    <td>
                                      {{ props.item.HeaderConsent }}
                                    </td>
                                    <td>
                                      <v-radio-group
                                        v-model="props.item.Status"
                                        row
                                      >
                                        <v-layout
                                          row
                                          wrap
                                          justify-center
                                          align-center
                                        >
                                          <v-flex lg6>
                                            <v-radio
                                              value="approve"
                                              color="success"
                                            ></v-radio>
                                          </v-flex>
                                          <v-flex lg6>
                                            <v-radio
                                              value="unapprove"
                                              color="error"
                                            ></v-radio>
                                          </v-flex>
                                        </v-layout>
                                      </v-radio-group>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <v-layout row wrap justify-center align-center>
                    <v-flex lg3 text-start>
                      <v-btn block dark color="error" @click="e1 = 1">
                        {{ $t("upload.back") }}
                      </v-btn>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex lg3 text-end>
                      <!-- <v-btn
                              block
                              dark
                              color="#077893"
                              @click="Fn_CheckConsent"
                            >
                              {{ $t("upload.next") }}
                            </v-btn> -->
                      <v-btn
                        v-if="
                          TypeConsent == 'general' &&
                          ItemPolicyId !== '' &&
                          ItemConsentGeneralId !== ''
                        "
                        block
                        dark
                        color="#077893"
                        @click="DialogConFirm"
                      >
                        {{ $t("upload.upload") }}
                      </v-btn>
                      <v-btn
                        v-else-if="
                          TypeConsent == 'group' && ItemConsentGroupId !== ''
                        "
                        block
                        dark
                        color="#077893"
                        @click="DialogConFirm"
                      >
                        {{ $t("upload.upload") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-card class="mb-12" color="white lighten-1" elevation="0">
                    <v-layout row wrap justify-center align-center>
                      <v-flex lg11>
                        <v-data-table
                          v-if="TypeConsent == 'general'"
                          dense
                          hide-default-footer
                          :headers="headers"
                          :items="itemDataConsent"
                          style="cursor: pointer"
                        >
                          <template v-slot:item="props">
                            <tr
                              @dblclick="
                                fn_getDataConsent(props.item.ConsentId)
                              "
                              class="text-center"
                            >
                              <td>
                                <div class="text-left">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        v-bind="attrs"
                                        color="#077893"
                                        style="cursor: pointer"
                                        small
                                        @click="
                                          Fn_CopyDetail(props.item.ConsentId)
                                        "
                                        v-on="on"
                                        >mdi-file-multiple-outline</v-icon
                                      >
                                    </template>
                                    <span>{{ $t("consentlist.copy") }}</span>
                                  </v-tooltip>
                                  {{ props.item.ConsentId }}
                                </div>
                              </td>
                              <td>{{ props.item.HeaderConsent }}</td>
                              <td v-if="$t('default') === 'th'">
                                {{ props.item.UpdatdeBy }}
                              </td>
                              <td v-if="$t('default') === 'th'">
                                {{ props.item.UpdatdeAt }}
                              </td>
                              <td v-if="$t('default') === 'en'">
                                {{ props.item.UpdatdeByEng }}
                              </td>
                              <td v-if="$t('default') === 'en'">
                                {{ props.item.UpdatdeAtEng }}
                              </td>
                              <td>
                                <v-radio-group v-model="StatusConsent" row>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                  >
                                    <v-flex lg6>
                                      <v-radio
                                        value="approve"
                                        color="success"
                                      ></v-radio>
                                    </v-flex>
                                    <v-flex lg6>
                                      <v-radio
                                        value="unapprove"
                                        color="error"
                                      ></v-radio>
                                    </v-flex>
                                  </v-layout>
                                </v-radio-group>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                        <v-data-table
                          v-else
                          dense
                          hide-default-footer
                          :headers="headersGroup"
                          :items="GroupConsent"
                          style="cursor: pointer"
                        >
                          <template v-slot:item="props">
                            <tr
                              @dblclick="
                                fn_getDataConsent(props.item.ConsentId)
                              "
                              class="text-center"
                            >
                              <td>
                                <div class="text-left">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        v-bind="attrs"
                                        color="#077893"
                                        style="cursor: pointer"
                                        small
                                        @click="
                                          Fn_CopyDetail(props.item.ConsentId)
                                        "
                                        v-on="on"
                                        >mdi-file-multiple-outline</v-icon
                                      >
                                    </template>
                                    <span>{{ $t("consentlist.copy") }}</span>
                                  </v-tooltip>
                                  {{ props.item.ConsentId }}
                                </div>
                              </td>
                              <td>{{ props.item.HeaderConsent }}</td>
                              <td>
                                <v-radio-group v-model="props.item.Status" row>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                  >
                                    <v-flex lg6>
                                      <v-radio
                                        value="approve"
                                        color="success"
                                      ></v-radio>
                                    </v-flex>
                                    <v-flex lg6>
                                      <v-radio
                                        value="unapprove"
                                        color="error"
                                      ></v-radio>
                                    </v-flex>
                                  </v-layout>
                                </v-radio-group>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <v-layout row wrap justify-center align-center>
                    <v-flex lg3 text-start>
                      <v-btn
                        block
                        dark
                        color="error"
                        @click="ClearitemDataConsent"
                      >
                        {{ $t("upload.back") }}
                      </v-btn>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex lg3 text-end>
                      <v-btn block dark color="#077893" @click="DialogConFirm">
                        {{ $t("upload.upload") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </v-layout>
        <SearchLogUpload></SearchLogUpload>
        <v-dialog v-model="dialog" width="700px" persistent scrollable>
          <v-divider></v-divider>
          <v-card>
            <!-- <v-card-title>
              <span>รายละเอียดความยินยอม</span>
            </v-card-title> -->
            <v-divider></v-divider>
            <br />
            <v-card-text>
              <!-- <b>{{ HeaderConsent }}</b> <br /> -->
              <b>{{ $t("upload.text1") }}: </b>{{ ShortConsent }} <br />
              <div v-if="$t('default') === 'th'">
                <br />
                <b>{{ $t("upload.text2") }}: </b>{{ UpdatdeBy }}
              </div>
              <div v-else>
                <br />
                <b>{{ $t("upload.text2") }}: </b>{{ UpdatdeByEng }}
              </div>
              <br />
              <b>{{ $t("upload.text3") }}: </b>{{ ExpireIn }}
              {{ $t("upload.text7") }} <br /><br />
              <v-card outlined>
                <v-card-title>{{ $t("upload.text4") }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text> <div v-html="DetailConsent"></div> </v-card-text>
              </v-card>
              <br />
              <v-card outlined>
                <v-card-title>{{ $t("upload.text5") }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text> <div v-html="RejectReason"></div> </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" outlined @click="dialog = false">
                {{ $t("upload.text6") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div v-if="loadingDownloadData">
          <OverlaySearch />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import SearchLogUpload from "./SearchLogUpload.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
const Swal = Swal2.mixin({
  toast: false,
  position: "center",
  showConfirmButton: true,
  // timer: 3000,
});

export default {
  components: { SearchLogUpload, OverlaySearch },
  data: function () {
    return {
      file: "",
      dragging: false,
      StatusBtn: 1,
      loadingDownloadData: false,
      StatusErr: "",
      e1: 0,
      acId: "",
      valid: true,
      oneid: "",
      name: "",
      phone: "",
      email: "",
      cardid: "",
      passport: "",
      bizid: "",
      itemconsent: [],
      itemconsent2: [],
      TypeConsent: "general",
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      ItemPolicy: [],
      ItemPolicyId: "",
      ItemConsentGeneralId: "",
      ItemConsentGroupId: "",
      itemDataConsent: [],
      itemDataConsentGroup: [],
      dialog: false,
      StatusConsent: "approve",
      HeaderConsent: "",
      UpdatdeBy: "",
      ShortConsent: "",
      ExpireIn: "",
      DetailConsent: "",
      RejectReason: "",
      UpdatdeByEng: "",
      GroupId: "",
      DetailGroupConsent: [],
      GroupConsent: [],
      DaTaConsent: "",
      pdfUrl: "",
      pdfLoad: false,
      btnDis: "false",
    };
  },
  methods: {
    ClearitemDataConsent() {
      this.e1 = 2;
      this.itemDataConsent = [];
      this.itemDataConsentGroup = [];
      this.GroupConsent = [];
      this.ItemConsentGroupId = [];
    },
    async fn_getDataConsent(val) {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        ConsentId: val,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.dialog = true;
            this.GetDataConsent = response.data.Message;
            this.HeaderConsent = response.data.Message[0].HeaderConsent;
            this.DetailConsent = response.data.Message[0].DetailsConsent;
            this.RejectReason = response.data.Message[0].RejectReason;
            this.BusinessNameTh = response.data.Message[0].BusinessNameTh;
            this.UpdatdeBy = response.data.Message[0].UpdatdeBy;
            this.UpdatdeByEng = response.data.Message[0].UpdatdeByEng;
            this.ExpireIn = response.data.Message[0].ExpireIn;
            this.ShortConsent = response.data.Message[0].ShortConsent;

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsentGroup(val) {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        GroupId: val.GroupId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetDetailGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.DetailGroupConsent = response.data.Message;
            this.GroupName = response.data.Message.GroupName;
            this.GroupId = response.data.Message.GroupId;
            this.GroupConsent = response.data.Message.Consent;
            this.ExpirationDate = response.data.Message.ExpireIn;
            for (var item of this.GroupConsent) {
              this.StatusConsent = "approve";
              item.Status = this.StatusConsent;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    DialogConFirm() {
      Swal.fire({
        // title: this.$t("upload.swal1"),
        title:
          "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
          this.$t("upload.swal1") +
          "</span>",
        // text: this.$t("upload.swal2"),
        html:
          "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
          this.$t("upload.swal2") +
          "</span>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#077893",
        cancelButtonColor: "#b33",
        // cancelButtonText: this.$t("upload.swal4"),
        cancelButtonText:
          "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
          this.$t("upload.swal4") +
          "</span>",
        // confirmButtonText: this.$t("upload.swal3"),
        confirmButtonText:
          "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
          this.$t("upload.swal3") +
          "</span>",
      }).then((result) => {
        if (result.isConfirmed) {
          this.fn_SendConsent();
        }
      });
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    // async Fn_CheckConsent() {
    //   if (this.TypeConsent == "general") {
    //     if (this.ItemConsentGeneralId == "" || this.ItemPolicyId == "") {
    //       this.e1 = 2;
    //       Toast.fire({
    //         icon: "error",
    //         title: this.$t("upload.swal5"),
    //       });
    //     } else {
    //       // this.e1 = 3;
    //       this.ItemConsentGroupId = "";
    //       this.itemDataConsent.push(this.ItemConsentGeneralId);
    //     }
    //   } else if (this.TypeConsent == "group") {
    //     if (this.ItemConsentGroupId == "") {
    //       this.e1 = 2;
    //       Toast.fire({
    //         icon: "error",
    //         title: this.$t("upload.swal5"),
    //       });
    //     } else {
    //       // this.e1 = 3;
    //       this.ItemConsentGeneralId = "";
    //       this.ItemPolicyId = "";
    //       this.itemDataConsentGroup.push(this.ItemConsentGroupId);
    //       this.Fn_GetDataConsentGroup(this.ItemConsentGroupId);
    //     }
    //   }
    // },
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
      // this.Fn_SubmitFile();
    },
    createFile(file) {
      this.loadingDownloadData = true;
      this.pdfLoad = true;

      // Array ของชนิดไฟล์ที่รองรับ
      const allowedFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/bmp",
        "image/svg+xml",
        "image/webp",
        "application/pdf",
      ];

      // ตรวจสอบว่าชนิดของไฟล์อยู่ใน Array ที่กำหนดหรือไม่
      if (!allowedFileTypes.includes(file.type)) {
        this.loadingDownloadData = false;
        setTimeout(() => (this.pdfLoad = false), 1000);
        Toast.fire({
          icon: "error",
          title: this.$t("upload.swal6"),
        });
        this.dragging = false;
      } else if (file.size > 5000000) {
        this.loadingDownloadData = false;
        setTimeout(() => (this.pdfLoad = false), 1000);
        Toast.fire({
          icon: "error",
          title: "please check file size no over 5 MB.",
        });
        this.dragging = false;
      } else {
        this.loadingDownloadData = false;
        setTimeout(() => (this.pdfLoad = false), 1000);
        this.file = file;
        this.dragging = false;
        this.e1 = 1;
      }
    },
    removeFile() {
      this.file = "";
      this.oneid = "";
      this.name = "";
      this.phone = "";
      this.email = "";
      this.cardid = "";
      this.passport = "";
      this.bizid = "";
      this.e1 = 0;
      Toast.fire({
        icon: "success",
        title: this.$i18n.t("alert.del") + " " + this.$i18n.t("alert.success"),
      });
    },
    Fn_SubmitFile() {
      this.loadingDownloadData = true;
      var formData = new FormData();
      formData.append("AccountId", this.$cookies.get("OneAccountId"));
      formData.append("BusinessId", this.$cookies.get("BusinessId"));
      formData.append("ConsentPDF", this.file);

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "pdf/UploadFilePDF",
          // "http://192.168.21.153:8016/service/pdf/UploadFilePDF",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.e1 = 1;
            this.loadingDownloadData = false;
            this.DataImportPdf = response.data.Message;
            this.SendId = response.data.Message.SendId;
            this.StatusErr = response.data.Status;
            Toast.fire({
              icon: "success",
              title:
                this.$i18n.t("alert.upload") +
                " " +
                this.file.name +
                " " +
                this.$i18n.t("alert.success"),
            });
            this.StatusBtn = 2;
            // this.file = "";
          } else {
            this.loadingDownloadData = false;
            this.StatusErr = response.data.ErrorMessage;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          this.StatusErr = error.response.data.ErrorMessage;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    validate() {
      if (
        this.oneid == "" &&
        this.name == "" &&
        this.phone == "" &&
        this.email == "" &&
        this.cardid == "" &&
        this.passport == "" &&
        this.bizid == ""
      ) {
        this.$refs.form.validate();
        this.e1 = 1;
        Toast.fire({
          icon: "error",
          title: this.$t("upload.swal7"),
        });
      } else {
        this.$refs.form.resetValidation();
        this.e1 = 2;
      }
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async fn_SendConsent() {
      this.loadingDownloadData = true;
      if (this.TypeConsent == "group") {
        // for (let i = 0; i < this.GroupConsent.length; i++) {
        //   const consent = this.GroupConsent[i];
        //   delete consent.GroupConsentId;
        //   delete consent.HeaderConsent;
        //   delete consent.Level;
        // }
        var myStr = JSON.stringify(this.GroupConsent);
        var formData = new FormData();
        formData.append("AccountId", this.$cookies.get("OneAccountId"));
        formData.append("BusinessId", this.$cookies.get("BusinessId"));
        formData.append("ConsentPDF", this.file);
        formData.append("ConsentGroupId", this.ItemConsentGroupId.GroupId);
        formData.append("Consent", myStr);
        formData.append("PolicyId", "");
        // formData.append("OneId", this.oneid);
        formData.append("Name", this.name);
        formData.append("Tel", this.phone);
        formData.append("Email", this.email);
        formData.append("Idcard", this.cardid);
        formData.append("Passport", this.passport);
        // formData.append("BizId", this.bizid);
        formData.append("TaxId", this.bizid);
        formData.append("Username", this.oneid);
        // formData.append("Username", this.$cookies.get("OneUsername"));
        // var payload = {
        //   BusinessId: this.$cookies.get("BusinessId"),
        //   AccountId: this.$cookies.get("OneAccountId"),
        //   SendId: this.SendId,
        //   ConsentGroupId: this.ItemConsentGroupId.GroupId,
        //   Consent: this.GroupConsent,
        //   PolicyId: "",
        //   OneId: this.oneid,
        //   Name: this.name,
        //   Tel: this.phone,
        //   Email: this.email,
        //   Idcard: this.cardid,
        //   Passport: this.passport,
        //   BizId: this.bizid,
        // };
      } else if (this.TypeConsent == "general") {
        var DaTaConsent = [
          {
            ConsentId: this.ItemConsentGeneralId.ConsentId,
            Status: this.StatusConsent,
          },
        ];
        var myStr = JSON.stringify(DaTaConsent);
        this.DaTaConsent = DaTaConsent;

        var formData = new FormData();
        formData.append("AccountId", this.$cookies.get("OneAccountId"));
        formData.append("BusinessId", this.$cookies.get("BusinessId"));
        formData.append("ConsentPDF", this.file);
        formData.append("ConsentGroupId", "");
        formData.append("Consent", myStr);
        formData.append("PolicyId", this.ItemPolicyId);
        // formData.append("OneId", this.oneid);
        formData.append("Name", this.name);
        formData.append("Tel", this.phone);
        formData.append("Email", this.email);
        formData.append("Idcard", this.cardid);
        formData.append("Passport", this.passport);
        // formData.append("BizId", this.bizid);
        formData.append("TaxId", this.bizid);
        formData.append("Username", this.oneid);
        // formData.append("Username", this.$cookies.get("OneUsername"));
        // var payload = {
        //   BusinessId: this.$cookies.get("BusinessId"),
        //   AccountId: this.$cookies.get("OneAccountId"),
        //   ConsentPDF: this.file,
        //   SendId: this.SendId,
        //   ConsentGroupId: "",
        //   Consent: DaTaConsent,
        //   PolicyId: this.ItemPolicyId,
        //   OneId: this.oneid,
        //   Name: this.name,
        //   Tel: this.phone,
        //   Email: this.email,
        //   Idcard: this.cardid,
        //   Passport: this.passport,
        //   BizId: this.bizid,
        // };
      }
      this.axios
        .post(
          // process.env.VUE_APP_API_FACTORING_SERVICE + "pdf/SendConsent",
          process.env.VUE_APP_API_FACTORING_SERVICE + "pdf/UploadFilePDF",
          // "http://192.168.22.168:8016/service/pdf/UploadFilePDF",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.SentDataConsent = response.data.Message;
            Swal.fire(
              {
                title:
                  "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
                  this.$t("upload.swal8") +
                  "</span>",
                html:
                  "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
                  this.$t("upload.swal9") +
                  "</span>",
                icon: "success",
                confirmButtonColor: "#077893",
                confirmButtonText:
                  "<span style='font-family: Prompt, Helvetica, Arial, sans-serif;'>" +
                  this.$t("upload.swal3") +
                  "</span>",
              }
              // this.$t("upload.swal8"),
              // this.$t("upload.swal9"),
              // "success"
            ).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              } else {
                window.location.reload();
                {
                }
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    // downloadPDF() {
    //   const iframe = this.$refs.pdfFrame;
    //   iframe.contentWindow.postMessage({ action: "download" }, "*");
    // },
  },
  computed: {
    ...mapGetters(["StatusBusiness"]),
    ...mapGetters(["Business"]),
    AccountId: {
      get() {
        return this.$cookies.get("OneAccountId") || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
    headers() {
      return [
        {
          text: this.$t("consentlist.subject"),
          value: "HeaderConsent",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("upload.status"),
          value: "UpdatdeAt",
          sortable: false,
          align: "center",
        },
      ];
    },
    headersGroup() {
      return [
        {
          text: this.$t("consentlist.subject"),
          value: "GroupName",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("upload.status"),
          value: "StatusConsent",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetConsentGeneral();
    this.Fn_GetConsentGroup();
    this.Fn_GetPolicy();
  },
  watch: {
    async TypeConsent(val) {
      this.ItemPolicyId = "";
      this.ItemConsentGeneralId = "";
      this.ItemConsentGroupId = "";
      this.itemDataConsent = [];
      this.itemDataConsentGroup = [];
      // if (val === "SentAll") {
      //   this.$refs.formConsent.resetValidation();
      //   this.DisabledPosition = true;
      // }
      if (val === "general") {
        this.itemDataConsent = [];
        this.itemDataConsentGroup = [];
        // this.e1 = 3;
        this.ItemConsentGroupId = "";
        // this.itemDataConsent.push(this.ItemConsentGeneralId);
      } else if (val === "group") {
        // this.e1 = 3;
        this.ItemConsentGeneralId = "";
        this.ItemPolicyId = "";
        // this.itemDataConsentGroup.push(this.ItemConsentGroupId);
        // this.Fn_GetDataConsentGroup(this.ItemConsentGroupId);
      }
    },
    async ItemConsentGeneralId(val) {
      this.itemDataConsent = [];
      this.itemDataConsentGroup = [];
      this.itemDataConsent.push(val);
      this.btnDis = "true";
    },
    async ItemConsentGroupId(val) {
      this.itemDataConsent = [];
      this.itemDataConsentGroup = [];
      if (this.TypeConsent == "group") {
        this.btnDis = "true";
        this.itemDataConsentGroup.push(val);
        this.Fn_GetDataConsentGroup(val);
      }
    },
    // SelectDepartment(val) {
    //   if (val.DepartmentId === "00000") {
    //     this.Fn_GetAllEmployeeFromDepartment();
    //     this.SelectRole = "00000";
    //     this.DepartmentId = "00000";
    //     this.$refs.formConsent.resetValidation();
    //     this.DisabledPosition = true;
    //   } else if (this.TypeSent === "SentAll") {
    //     this.SelectRole = "";
    //     this.DisabledPosition = false;
    //   } else {
    //     this.SelectRole = "";
    //     this.DisabledPosition = false;
    //     this.Fn_GetDetailDepartment();
    //   }
    // },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.dropZone {
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
  transition: 0.3s;
  border-radius: 0.5rem;
}

.dropZone:hover {
  border: 2px dashed #077893;
  opacity: 1;
  border-radius: 0.5rem;
  background-color: #00000021;
}

.dropZone:hover .dropZone-title {
  color: #077893;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
  border-radius: 0.5rem;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}

.v-input__slot {
  display: flex !important;
  justify-content: center !important;
}

.fix {
  position: absolute;
  left: 0;
  top: 0;
}

.fix2 {
  position: absolute;
  left: 0;
  top: 0;
}

.v-radio {
  align-items: center;
  display: flex;
  height: auto;
  outline: none;
  justify-content: center;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 0 !important;
}

.swal2-content,
div#swal2-content {
  font-family: Prompt, Helvetica, Arial, sans-serif !important;
}
</style>
